module.exports = __webpack_public_path__ + "static/background-3f1ac4db02474fbeff087961ccf6551c.jpg";